import React from "react"
import DocumentListContainer from "./DocumentListContainer"

const ScopedDocumentListContainer = ({ id, slug, category, viewType }) => (
    <DocumentListContainer
        mode="scoped"
        id={id}
        slug={slug}
        scope={category || "PARTY"}
        viewType={viewType || null}
    />
)

export default ScopedDocumentListContainer
